<template>
<div>

    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

        <div class="m-2">

            <!-- Table Top -->
            <b-row>

                <!-- Per Page -->
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                    <label>{{ $t('Show')}}</label>
                    <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
                    <label>{{ $t('entries')}}</label>
                </b-col>

                <!-- Search -->
                <b-col cols="12" md="6">
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')" />
                        <b-button v-if="user.role == 'TRCKOWN' || user.role == 'SERVSHAR'" variant="primary" :to="{ name: 'register-dealer' }">
                            <span class="text-nowrap">{{ $t('Add Dealer')}}</span>
                        </b-button>
                    </div>
                </b-col>
            </b-row>

        </div>

        <b-table ref="refDealerListTable" class="position-relative" :items="fetchDealers" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="emptyText" :sort-desc.sync="isSortDirDesc">

            <!-- Column: dealer -->
            <template #head(plate)>
                {{ $t('Dealer')}}
            </template>
            <template #cell(name)="data">
                <b-media vertical-align="center">
                    <template #aside>
                        <b-avatar variant="light-primary" size="40" :to="{ name: 'apps-users-view', params: { id: data.item.id } }">
                            <feather-icon icon="UsersIcon" size="25" />
                        </b-avatar>
                    </template>
                    <b-link :to="{ name: 'apps-users-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap">
                        {{ data.item.name }}
                    </b-link>
                    <small class="text-muted">{{ $t('Owner')}}: <strong>{{ data.item.ownerName }}</strong></small>
                </b-media>
            </template>

            <!-- Column: Address 
            <template #cell(address)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.address }}
                </div>
            </template>

             Column: Contact 
            <template #cell(contact)="data">
                <div class="font-weight-bold d-block text-nowrap">

                    {{ data.item.contactName ? data.item.contactName : data.item.fullName }}

                    <small class="text-muted d-block">{{ $t('Tel:') }} <strong>{{ data.item.contact }}</strong> </small>
                    <small class="text-muted d-block">{{ $t('Email:') }} <strong>{{ data.item.email }}</strong> </small>
                </div>
            </template>-->

            <!-- Column: Document -->
            <template #head(document)>
                {{ $t('Document')}}
            </template>
            <template #cell(document)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.document }}
                </div>
            </template>

            <!-- Column: Email -->
            <template #head(email)>
                {{ $t('Email')}}
            </template>
            <template #cell(email)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.email }}
                </div>
            </template>

            <!-- Column: manager -->
            <template #head(manager)>
                {{ $t('Manager')}}
            </template>
            <template #cell(manager)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.manager }}
                </div>
            </template>

            <!-- Column: managerEmail -->
            <template #head(managerEmail)>
                {{ $t('Manager Email')}}
            </template>
            <template #cell(managerEmail)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.managerEmail }}
                </div>
            </template>

            <!-- Column: managerPhone -->
            <template #head(managerPhone)>
                {{ $t('Manager Phone')}}
            </template>
            <template #cell(managerPhone)="data">
                <div class="font-weight-bold d-block text-nowrap">
                    {{ data.item.managerPhone }}
                </div>
            </template>

            <!-- Column: Actions -->
            <template #head(actions)>
                {{ $t('Actions')}}
            </template>
            <template #cell(actions)="data">
                <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

                    <template #button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>

                    <b-dropdown-item v-if="user.role == 'TRCKOWN' || user.role == 'SERVSHAR'" :to="{ name: 'register-dealer', params: { id: data.item.id } }">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">{{ $t('Edit')}}</span>
                    </b-dropdown-item>

                    <b-dropdown-item @click="modalDelete(data.item.id)" v-if="user.role == 'TRCKOWN' || user.role == 'SERVSHAR'">
                        <feather-icon icon="Trash2Icon" />
                        <span class="align-middle ml-50">{{ $t('Delete')}}</span>
                    </b-dropdown-item>
                </b-dropdown>
            </template>

        </b-table>
        <div class="mx-2 mb-2">
            <b-row>

                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                    <span class="text-muted"> {{ $t('Showing')}} {{ dataMeta.from }} {{ $t('to')}} {{ dataMeta.to }} {{ $t('of')}} {{ dataMeta.of }}{{ $t('entries')}} </span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                    <b-pagination v-model="currentPage" :total-rows="totalDealers" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>

                </b-col>

            </b-row>
        </div>
    </b-card>
</div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
    ref,
    onUnmounted
} from '@vue/composition-api'
import {
    avatarText
} from '@core/utils/filter'
import useDealersList from './useDealersList'
import dealerStoreModule from './dealerStoreModule'

export default {
    components: {

        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,

        vSelect,
    },
    data(){
        return {
            emptyText: this.$t('No matching records found')
        }
    },
    methods: {
        modalDelete(myId) {
            this.$swal({
                title: this.$t('Are you sure?'),
                text: this.$t("You can't revert your action"),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('Yes'),
                cancelButtonText: this.$t('No'),
                showCloseButton: true,
                showLoaderOnConfirm: true,
                customClass: {
                    cancelButton: 'cancelBtn',
                    confirmButton: 'mr-1',
                }
            }).then((result) => {
                if (result.value) {
                    this.deleteDealer(myId)

                } else {}
            })
        },

        deleteDealer(myId) {
            store.dispatch('app-dealer/deleteDealer', {
                    id: myId
                })
                .then(response => {
                    this.$swal(this.$t("Deleted"), `${this.$t("You successfully deleted")}`, 'success')
                    .then((result) => {
                        if (result.value) {
                            this.refetchData()

                        } else {}
                    })
                })
                .catch(error => {
                    this.$swal(this.$t('Error'), this.$t('An error occurred while trying to delete'), 'error')
                })
        }
    },
    setup() {
        const DEALER_APP_STORE_MODULE_NAME = 'app-dealer'

        // Register module
        if (!store.hasModule(DEALER_APP_STORE_MODULE_NAME)) store.registerModule(DEALER_APP_STORE_MODULE_NAME, dealerStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(DEALER_APP_STORE_MODULE_NAME)) store.unregisterModule(DEALER_APP_STORE_MODULE_NAME)
        })


        const user = localStorage.userData != undefined ? JSON.parse(localStorage.userData) : {}

        

        const {
            fetchDealers,
            tableColumns,
            perPage,
            currentPage,
            totalDealers,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refDealerListTable,
            refetchData,
        } = useDealersList()

        return {

            // Sidebar

            fetchDealers,
            tableColumns,
            perPage,
            currentPage,
            totalDealers,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refDealerListTable,
            refetchData,

            user

           
        }
    },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
    width: 90px;
}
</style><style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
